<table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort class="mat-elevation-z1 full-width">

  <!-- Expand toggle -->
  <ng-container matColumnDef="expand">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let row">
      <button mat-icon-button type="button" (click)="toggleRow(row); $event.stopPropagation()"
        [disabled]="!(row.subRequests?.length)">
        <mat-icon>{{ expandedElement === row ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
    </td>
  </ng-container>

  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <button mat-button class="filter-button" type="button"
        (click)="$event.stopPropagation()"
        [matMenuTriggerFor]="filterComponent.filterMenu"
        [matMenuTriggerData]="{ caller: 'id' }">
        {{ 'dataManagement.dataExchangeRequests.columns.id' | transloco }}
        <mat-icon class="filter-icon" *ngIf="filteredColumns.includes('id')">filter_alt</mat-icon>
      </button>
    </th>
    <td mat-cell *matCellDef="let row">{{ row.id }}</td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <button mat-button class="filter-button" type="button"
        (click)="$event.stopPropagation()"
        [matMenuTriggerFor]="filterComponent.filterMenu"
        [matMenuTriggerData]="{ caller: 'name' }">
        {{ 'dataManagement.dataExchangeRequests.columns.name' | transloco }}
        <mat-icon class="filter-icon" *ngIf="filteredColumns.includes('name')">filter_alt</mat-icon>
      </button>
    </th>
    <td mat-cell *matCellDef="let row">{{ row.name }}</td>
  </ng-container>

  <ng-container matColumnDef="createdAt">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <button mat-button class="filter-button" type="button"
        (click)="$event.stopPropagation()"
        [matMenuTriggerFor]="filterComponent.dateFilterMenu"
        [matMenuTriggerData]="{ caller: 'createdAt' }">
        {{ 'dataManagement.dataExchangeRequests.columns.createdAt' | transloco }}
        <mat-icon class="filter-icon" *ngIf="filteredColumns.includes('createdAt')">filter_alt</mat-icon>
      </button>
    </th>
    <td mat-cell *matCellDef="let row">{{ getDate(row.createdAt) | date:'short' }}</td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <button mat-button class="filter-button" type="button"
        (click)="$event.stopPropagation()"
        [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
        [matMenuTriggerData]="{ caller: 'status', categories: getStatusOptions() }">
        {{ 'dataManagement.dataExchangeRequests.columns.status' | transloco }}
        <mat-icon class="filter-icon" *ngIf="filteredColumns.includes('status')">filter_alt</mat-icon>
      </button>
    </th>
    <td mat-cell *matCellDef="let row">{{ getStatusLabel(row.status) | transloco }}</td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let row">
      <ng-container *ngIf="!isReceived">
        <button mat-icon-button type="button"
          [title]="'dataManagement.dataExchangeRequests.actions.withdraw' | transloco"
          [disabled]="row.status === requestStatus.Deleted"
          (click)="onWithdrawRequest(row); $event.stopPropagation()">
          <mat-icon>undo</mat-icon>
        </button>
        <button mat-icon-button type="button"
          [title]="'dataManagement.dataExchangeRequests.actions.approve' | transloco"
          [disabled]="!allSubRequestsSubmitted(row)"
          (click)="onApproveRequest(row); $event.stopPropagation()">
          <mat-icon>done_all</mat-icon>
        </button>
      </ng-container>
    </td>
  </ng-container>

  <ng-container matColumnDef="counterpart">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <button mat-button class="filter-button" type="button"
        (click)="$event.stopPropagation()"
        [matMenuTriggerFor]="filterComponent.multiSelectFilterMenu"
        [matMenuTriggerData]="{ caller: 'counterpart', categories: getCounterpartOptions(), translation: 'counterpart' }">
        {{ (isReceived ? 'dataManagement.dataExchangeRequests.columns.sender' : 'dataManagement.dataExchangeRequests.columns.recipient') | transloco }}
        <mat-icon class="filter-icon" *ngIf="filteredColumns.includes('counterpart')">filter_alt</mat-icon>
      </button>
    </th>
    <td mat-cell *matCellDef="let row">{{ isReceived ? row.sendingSecurityPrincipal?.name : row.receivingSecurityPrincipal?.name }}</td>
  </ng-container>

  <ng-container matColumnDef="subRequestCount">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <button mat-button class="filter-button" type="button"
        (click)="$event.stopPropagation()"
        [matMenuTriggerFor]="filterComponent.filterMenu"
        [matMenuTriggerData]="{ caller: 'subRequestCount' }">
        {{ 'dataManagement.dataExchangeRequests.columns.items' | transloco }}
        <mat-icon class="filter-icon" *ngIf="filteredColumns.includes('subRequestCount')">filter_alt</mat-icon>
      </button>
    </th>
    <td mat-cell *matCellDef="let row">{{ row.subRequests?.length ?? 0 }}</td>
  </ng-container>

  <!-- Expandable detail row -->
  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
      <div class="detail-container"
        [@detailExpand]="row === expandedElement ? 'expanded' : 'collapsed'">
        <ng-container *ngIf="row === expandedElement && getSubDataSources(row) as sds">
          <div style="border: 1px solid rgba(0, 0, 0, 0.12);margin: 32px;">
            <app-packaging-systems-overview
              *ngIf="sds.systems.data.length > 0"
              [dataSource]="sds.systems"
              [displayedColumns]="systemColumns"
              [subRequestMap]="sds.systemSubRequestMap"
              [commentCountMap]="sds.systemCommentCountMap"
              (navigateToSubRequest)="onNavigateSystemSubRequest($event, row)"
              (approveSubRequest)="onApproveSystemSubRequest($event, row)"
              (reopenSubRequest)="onReopenSystemSubRequest($event, row)"
              (withdrawSubRequest)="onWithdrawSystemSubRequest($event, row)"
              (showSubRequestComments)="onShowSystemSubRequestComments($event, row)">
            </app-packaging-systems-overview>
            <app-packaging-units-overview
              *ngIf="sds.units.data.length > 0"
              [dataSource]="sds.units"
              [displayedColumns]="unitColumns"
              [subRequestMap]="sds.unitSubRequestMap"
              [commentCountMap]="sds.unitCommentCountMap"
              (navigateToSubRequest)="onNavigateUnitSubRequest($event, row)"
              (approveSubRequest)="onApproveUnitSubRequest($event, row)"
              (reopenSubRequest)="onReopenUnitSubRequest($event, row)"
              (withdrawSubRequest)="onWithdrawUnitSubRequest($event, row)"
              (showSubRequestComments)="onShowUnitSubRequestComments($event, row)">
            </app-packaging-units-overview>
            <app-packaging-components-overview
              *ngIf="sds.components.data.length > 0"
              [dataSource]="sds.components"
              [displayedColumns]="componentColumns"
              [subRequestMap]="sds.componentSubRequestMap"
              [commentCountMap]="sds.componentCommentCountMap"
              (navigateToSubRequest)="onNavigateComponentSubRequest($event, row)"
              (approveSubRequest)="onApproveComponentSubRequest($event, row)"
              (reopenSubRequest)="onReopenComponentSubRequest($event, row)"
              (withdrawSubRequest)="onWithdrawComponentSubRequest($event, row)"
              (showSubRequestComments)="onShowComponentSubRequestComments($event, row)">
            </app-packaging-components-overview>
            <app-composite-materials-overview
              *ngIf="sds.materials.data.length > 0"
              [dataSource]="sds.materials"
              [displayedColumns]="materialColumns"
              [subRequestMap]="sds.materialSubRequestMap"
              [commentCountMap]="sds.materialCommentCountMap"
              (navigateToSubRequest)="onNavigateMaterialSubRequest($event, row)"
              (approveSubRequest)="onApproveMaterialSubRequest($event, row)"
              (reopenSubRequest)="onReopenMaterialSubRequest($event, row)"
              (withdrawSubRequest)="onWithdrawMaterialSubRequest($event, row)"
              (showSubRequestComments)="onShowMaterialSubRequestComments($event, row)">
            </app-composite-materials-overview>
          </div>
        </ng-container>

        <!-- Comments -->
        <div class="comments-section">
          <h4 class="comments-title">{{ 'dataManagement.dataExchangeRequests.comments.title' | transloco }}</h4>
          <app-data-exchange-comments
            [comments]="row.comments"
            (commentAdded)="onCommentAdded($event, row)">
          </app-data-exchange-comments>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"
    class="request-row"
    [class.expanded-row]="expandedElement === row"
    [class.notificationBackground]="isReceived ? row.hasNotificationForReceiver : row.hasNotificationForSender"
    (click)="toggleRow(row)">
  </tr>
  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>

  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
      {{ 'dataManagement.dataExchangeRequests.noData' | transloco }}
    </td>
  </tr>
</table>

<app-filter-menu #filterComponent="columnFilterComponent" [dataSource]="dataSource"></app-filter-menu>
